import React, { useEffect } from 'react'
import { NumberFieldSeeker } from "@ui-seeker/core"
import { useValidatorSeeker } from "@ui-seeker/app"
import { object, string } from "yup"

import { useAlertsDataInfo } from "Pages/ReportsAlerts/Alerts/Conditions/@hooks"
import { alertsDrawerData, alertsDrawerErrors } from "Pages/ReportsAlerts/Alerts/Conditions/@signals"


export default function PositionPrice() {
	const { dataInfo, setDataInfo } = useAlertsDataInfo(alertsDrawerData.peek().positionPrice || null)
	const { errors, isValid } = useValidatorSeeker({ positionPrice: dataInfo.value }, object({
		positionPrice: string().nullable().test('price', 'Position price must be between 1 and 10', a => a <= 10 && a > 0)
	}))

	useEffect(() => {
		alertsDrawerErrors.value = { ...alertsDrawerErrors.value, positionPrice: isValid }
	}, [JSON.stringify(errors)])

	return <NumberFieldSeeker
		startIcon="trophy"
		startIconProps={{
			sx: {
				color: "warning.main",
				mb: .3
			},
		}}
		value={dataInfo.value || ""}
		onChange={e => setDataInfo(e.target.value, 'positionPrice')}
		label="Position Price"
		placeholder="Any"
		error={errors.positionPrice}
	/>
}